<h3 class="mat-h3 registration-header">
  {{ registrationLabels.header }}<br />
  <span class="mat-h4 sub-header">{{ registrationLabels.subheader }}</span>
</h3>
<form
  class="registration-form"
  [formGroup]="form"
  (ngSubmit)="submitted.emit(form.getRawValue())"
>
  <h4 class="mat-h5 registration-section-header">
    <span>{{ registrationLabels.personalInfoHeader }}</span>
    <span
      class="review-container"
      *ngIf="isNewUser"
      [ngClass]="{
        'review-status': personalDetailsAreValid && !isConfirmed,
        'review-confirm-status': personalDetailsAreValid && isConfirmed
      }"
    >
      <img
        class="status-icon"
        *ngIf="personalDetailsAreValid && !isConfirmed"
        src="assets\images\alert-icon.svg"
        alt="alert icon"
      />
      <img
        class="status-icon"
        *ngIf="personalDetailsAreValid && isConfirmed"
        src="assets\images\check-circle-icon.svg"
        alt="check icon"
      />
      {{ reviewStatus }}
    </span>
  </h4>
  <div class="registration-personal-info">
    <ng-container *ngFor="let field of personalFields; let fieldIndex = index">
      <ng-container [ngSwitch]="field.controlType">
        <mat-form-field *ngSwitchCase="controlTypes?.INPUT">
          <mat-label>{{ field.fieldLabel }}</mat-label>
          <input
            matInput
            [type]="field.controlType!"
            [formControlName]="field.name!"
          />
          <mat-error
            *ngIf="
              form.controls[field.name!]?.invalid &&
              (form.controls[field.name!]?.touched ||
                form.controls[field.name!]?.dirty)
            "
          >
            <span
              *ngIf="getErrorsMsg(field.fieldLabel, form.controls[field.name!])"
            >
              {{ errorMsgToDisplay }}
            </span>
          </mat-error>
        </mat-form-field>
        <ng-container *ngSwitchCase="controlTypes?.DATE">
          <div class="dob-component">
            <label class="dob-label">{{
              labels?.stellar?.registration?.dateOfBirth
            }}</label>
            <app-dob-dropdown
              formControlName="dateOfBirth"
              [isDOBValid]="isDOBValid"
              [labels]="dateOfBirthComponent"
            ></app-dob-dropdown>
            <mat-error>
              <ng-container
                *ngIf="
                  !form!.get('dateOfBirth')?.errors?.required &&
                  form!.get('dateOfBirth')?.errors?.invalidOption
                "
                >{{
                  labels?.stellar?.registration?.dateOfBirthComponent
                    ?.enterValidDOB
                }}</ng-container
              >
              <ng-container
                *ngIf="
                  !form!.get('dateOfBirth')?.errors?.required &&
                  form!.get('dateOfBirth')?.errors?.min
                "
                >{{
                  labels?.stellar?.registration?.errorMsgs?.max
                }}</ng-container
              >
              <ng-container
                *ngIf="
                  !form!.get('dateOfBirth')?.errors?.required &&
                  form!.get('dateOfBirth')?.errors?.max
                "
                >{{
                  labels?.stellar?.registration?.errorMsgs?.min
                }}</ng-container
              >
            </mat-error>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <div
    *ngIf="personalDetailsAreValid && isNewUser"
    class="personal-info-confirmation-container"
  >
    <mat-checkbox
      formControlName="personalInfoConfirmation"
      class="personal-info-checkbox"
      ><strong>{{
        registrationLabels.confirmationCheckBoxStrings?.stringOne
      }}</strong></mat-checkbox
    >
    <div class="personal-info-help-text">
      <span>{{
        registrationLabels.confirmationCheckBoxStrings?.stringTwo
      }}</span>
    </div>
  </div>

  <h4 class="mat-h5 registration-section-header">
    {{ labels.stellar.registration.currentAddressInfoHeader }}
  </h4>
  <div class="registration-address-phone">
    <ng-container *ngFor="let field of addressFields; let fieldIndex = index">
      <ng-container
        *ngIf="
          field.name !== formFields.mobileNumber &&
          field.name !== formFields.mobileCountry
        "
      >
        <ng-container [ngSwitch]="field.controlType">
          <mat-form-field *ngSwitchCase="controlTypes?.INPUT">
            <mat-label>{{ field.fieldLabel }}</mat-label>
            <input
              matInput
              [type]="field.controlType!"
              [formControlName]="field.name!"
              [id]="field.name!"
            />
            <mat-error
              *ngIf="
                (form.controls[field.name!]?.invalid &&
                  (form.controls[field.name!]?.touched ||
                    form.controls[field.name!]?.dirty)) ||
                form.controls[field.name]?.hasError('noSpaces')
              "
            >
              <span
                *ngIf="
                  getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                "
              >
                {{ errorMsgToDisplay }}
              </span>
            </mat-error>
          </mat-form-field>

          <ng-container *ngIf="field.name !== formFields.state">
            <mat-form-field
              *ngSwitchCase="controlTypes?.SELECT"
              class="country-form-field"
            >
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <input
                [id]="field.name"
                type="text"
                [attr.aria-label]="field.fieldLabel"
                matInput
                [formControlName]="field.name!"
                [matAutocomplete]="autoRef"
              />
              <mat-icon class="arrow-icon" matSuffix>{{
                countryArrowIcon
              }}</mat-icon>
              <mat-autocomplete
                [displayWith]="
                  getSelectedOptionLabel.bind(this, countries, 'code')
                "
                (opened)="onAutoCompleteCountryPanelToggle(true)"
                (closed)="onAutoCompleteCountryPanelToggle(false)"
                #autoRef="matAutocomplete"
              >
                <ng-container *ngFor="let option of filteredCountries | async">
                  <mat-option [value]="option.name">
                    {{ option.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>

              <mat-error
                *ngIf="
                  form.controls[field.name!]?.invalid &&
                  (form.controls[field.name!]?.touched ||
                    form.controls[field.name!]?.dirty)
                "
              >
                <span
                  *ngIf="
                    getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                  "
                >
                  {{ errorMsgToDisplay }}
                </span>
              </mat-error>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="field.name === formFields.state">
            <mat-form-field *ngSwitchCase="controlTypes?.SELECT">
              <mat-label>{{ field.fieldLabel }}</mat-label>
              <input
                [id]="field.name"
                type="text"
                [attr.aria-label]="field.fieldLabel"
                matInput
                [formControlName]="field.name!"
                [matAutocomplete]="autoCompleteRef"
              />
              <mat-icon class="arrow-icon" matSuffix>{{
                stateArrowIcon
              }}</mat-icon>
              <mat-autocomplete
                [displayWith]="
                  getSelectedOptionLabel.bind(this, stateOptions, 'code')
                "
                (opened)="onAutoCompleteStatePanelToggle(true)"
                (closed)="onAutoCompleteStatePanelToggle(false)"
                #autoCompleteRef="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of filteredStates | async"
                  [value]="option.name"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  form.controls[field.name!]?.invalid &&
                  (form.controls[field.name!]?.touched ||
                    form.controls[field.name!]?.dirty)
                "
              >
                <span
                  *ngIf="
                    getErrorsMsg(field.fieldLabel, form.controls[field.name!])
                  "
                >
                  {{ errorMsgToDisplay }}
                </span>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="field.name === formFields.mobileNumber">
        <app-phone-number
          #phoneNumber
          class="phone-number-component"
          [parentForm]="form"
          [phoneFieldConfig]="mobileNumberConfig"
          [countryFieldConfig]="mobileCountryConfig"
          [phoneData]="phoneData"
          [transactionCountryCode]="transactionCountryCode"
          [locale]="locale"
          [labels]="labels"
        >
        </app-phone-number>
      </ng-container>
    </ng-container>
  </div>

  <div class="registration-button-row">
    <button
      color="primary"
      mat-raised-button
      type="submit"
      [disabled]="form.invalid || !!form.get('dateOfBirth')?.errors"
    >
      {{ labels.stellar.next }}
    </button>
  </div>
</form>
